import styled from 'styled-components'

export const NavbarItem = styled.div`
  display: flex;
  margin-left: 8px;
`
